import { Select } from '@mantine/core';
import React, { useCallback } from 'react';
import { useLanguage } from '../../i18n/LanguageProvider';
import { COUNTRIES } from '../../utils/contants';

type PhoneNumberInputProps = {
  country: string;
  setCountry: (value: string) => void;
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  placeholder?: string;
  style?: React.CSSProperties;
  selectStyle?: React.CSSProperties;
  error?: boolean;
  helperText?: string;
  onBlur?: () => void;
  disabled?: boolean;
};

export const PhoneNumberInput = ({
  country,
  setCountry,
  phoneNumber,
  setPhoneNumber,
  placeholder,
  style,
  selectStyle,
  error = false,
  helperText,
  onBlur,
  disabled = false,
}: PhoneNumberInputProps) => {
  const { messages } = useLanguage();

  const handleSelectCountry = useCallback(
    (value: string | null) => {
      if (value) {
        setCountry(value);
        setPhoneNumber('');
      }
    },
    [setCountry, setPhoneNumber]
  );

  const handleChangePhoneNumber = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      if (value.length > 15) return;
      if (value === '' || value.match(/^\d+$/)) {
        setPhoneNumber(value);
      }
    },
    [setPhoneNumber]
  );

  const countryData = COUNTRIES.map(c => ({
    value: c.id,
    label: c.name,
  }));

  return (
    <div style={style}>
      <div style={{ display: 'flex', gap: '10px' }}>
        <Select
          value={country}
          onChange={handleSelectCountry}
          data={countryData}
          styles={{ root: { width: 200, ...selectStyle } }}
          disabled={disabled}
          searchable
        />
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            border: `1px solid ${error ? '#f44336' : '#ced4da'}`,
            borderRadius: '4px',
            padding: '0 12px',
            height: '36px',
            backgroundColor: disabled ? '#f5f5f5' : 'white',
          }}
        >
          <span
            style={{
              color: '#64748b',
              marginRight: '8px',
              fontSize: '0.875rem',
              userSelect: 'none',
            }}
          >
            +{country}
          </span>
          <input
            type="tel"
            value={phoneNumber}
            onChange={handleChangePhoneNumber}
            onBlur={onBlur}
            placeholder={placeholder ?? messages.clients.phoneNumber}
            required
            disabled={disabled}
            style={{
              flex: 1,
              border: 'none',
              outline: 'none',
              fontSize: '0.875rem',
              backgroundColor: 'transparent',
            }}
          />
        </div>
      </div>
      {helperText && (
        <p
          style={{
            margin: '3px 14px 0',
            fontSize: '0.75rem',
            color: error ? '#f44336' : '#64748b',
          }}
        >
          {helperText}
        </p>
      )}
    </div>
  );
};
